import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function ProspectEmplyeeIdForm({ prospectEmployeeId, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Employee ID:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="employeeId"
          id="employeeId"
          placeholder="Employee ID"
          value={prospectEmployeeId || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(ProspectEmplyeeIdForm);
